import React from "react";
import ReactDOM from "react-dom";
import { StrictMode } from 'react';
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { unregister } from "./registerServiceWorker";

import App from "./App";
import "./components/Storage";
import { hashUserId, setGaUser } from "./analytics";

import "./style.scss";

const GA_MEASUREMENT_ID = 'G-BBD0NSPHVE';

// Seed hashed user_id on initial load so the first page_view is attributed.
try {
  const storedUser = window.localStorage.getItem('user');
  if (storedUser) {
    const parsed = JSON.parse(storedUser);
    if (parsed && parsed.username) {
      hashUserId(parsed.username).then((hashed) => setGaUser(GA_MEASUREMENT_ID, hashed));
    }
  }
} catch (e) { /* ignore */ }

const trackPageView = (location) => {
  if (typeof window.gtag !== 'function') return;
  const path = (location.basename || '') + location.pathname + (location.search || '');
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
};

const history = createBrowserHistory();
history.listen((location) => trackPageView(location));
trackPageView(history.location);

ReactDOM.render(
  <StrictMode>
    <Router history={history}>
      <App gaId={GA_MEASUREMENT_ID} />
    </Router>
  </StrictMode>,
  document.getElementById("root")
);

unregister();
